import React, { useEffect, useState } from 'react'
import IsecNavbar from './IsecNavbar'
import './pages-css/VulnerabilityPage.css'
import IsecNavbar2 from './IsecNavbar2'
import { useAuth } from '../../Context/UserContext';
import { url } from '../../constants/url';
import { toast } from 'react-toastify';


function VulnerabilityPage() {

  const [allVulnerability, setAllVulnerability] = useState([])
  const {isecSidebarCollapsed, logout} = useAuth();


  const fetchAllVulnerability = async () => {
    try {
      const response = await fetch(`${url}/allvulnerabilitydata`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
      })
      const data = await response.json()
      setAllVulnerability(data)
      if (response.status === 440) {
        logout()
        toast.error("User logout due to inactivity", {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });
        return
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchAllVulnerability();
  }, [])

  const getVulStatus = (severity) => {
    switch (severity) {
      case 'Critical': return 'critical';
      case 'High': return 'high';
      case 'Medium': return 'medium';
      case 'Low': return 'low';
      case 'Info': return 'info';
      default: return '';
    }
  };

  return (

    <div className='wrap_vulner_page'>
      <div className={isecSidebarCollapsed ? 'vulner_page_navbar' : "vulner_page_close_navbar"}>
        <IsecNavbar />
      </div>
      <div className='vulnera_page_container'>
        <div className='vulner_page_navbar2'>
          <IsecNavbar2 />
        </div>
        <div className='wrap_vulnerabilities_table'>
          <div className='vulnerability-table'>
            <table className='vul-table_list'>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Client Name</th>
                  <th>Project Name</th>
                  <th>Vulnerability Name</th>
                  <th>Severity</th>
                  <th>Added By</th>
                </tr>
              </thead>
              <tbody>
                {allVulnerability.length === 0 ? (
                  <tr className='collapse'>
                    <td colSpan='6' style={{ color: "red", fontWeight: "500", textAlign:'center' }}>
                      Vulnerability records not found....
                    </td>
                  </tr>
                ) : (
                  allVulnerability.map((vul, index) => (
                    <tr key={index}>
                      <td>{index+1}</td>
                      <td>{vul.clientName}</td>
                      <td>{vul.projectName}</td>
                      <td>{vul.vulnerabilityName}</td>
                      <td><div className={getVulStatus(vul.severity)}>{vul.severity}</div></td>
                      <td>{vul.addedby}</td>
                    </tr>
                  ))

                )}

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VulnerabilityPage
